import React, { useState, useEffect } from "react";
import { Button, Text } from "components";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "react-modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaRegTrashCan } from "react-icons/fa6";
import Select from "react-select";

function DeliveryChallanItemAdd() {
  const [editIndex, setEditIndex] = useState(null);
  const [visible, setvisible] = useState(true);
  const [selecteditem, setselecteditem] = useState(null);
  const [itemList, setitemList] = useState([]);
  const [itemListForLastDCType, setitemListLastDCType] = useState([]);
  const [itemDetails, setItemDetails] = useState({});
  const [itemByID, setItemByID] = useState({});
  const { id } = useParams();
  const { delivery_challan_type_id } = useParams();
  const { customer_id } = useParams();
  const [itemId, setitemId] = useState();
  const [costPrice, setCostPrice] = useState();
  console.log("delivery_challan_type_id",delivery_challan_type_id);

  let navigate = useNavigate();
  const [erplist, setErplist] = useState([]);
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");
    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 51 && item.add
  );

  //  if delivery_challan_type_id is 1, 2 ,3

  useEffect(() => {
    if (
      delivery_challan_type_id == 1 ||
      delivery_challan_type_id == 2 ||
      delivery_challan_type_id == 3
    ) {
      getItemList();
    }
  }, []);

  const [salesOrderItem, setSalesOrderItem] = useState({
    delivery_challan_id: id,
    item_detail_id: itemId,
    quantity: "",
    cost_price: costPrice,
  });

  const handleInputGet = (e) => {
    setItemDetails(() => ({
      ...itemDetails,
      [e.target?.name]: e.target?.value,
    }));
  };

  const ItemLists = { customer_id: customer_id };
  const getItemList = () => {
    axios
      .post("/api/purple-fusion/itemdetail/get/customer", ItemLists, headers)
      .then((res) => {
        setitemList(res.data);
        console.log(res.data);
      });
  };

  const sortedItemList = itemList.slice().sort((a, b) => b.id - a.id);
  const itemsDetailsGetByID = (iId) => {
    const obj = {
      item_detail_id: iId,
      delivery_challan_id: id,
    };
    axios
      .post(
        "/api/purple-fusion/delivarychallanitem/getitemdetaisfordeliverychallan",
        obj,
        headers
      )

      .then((response) => {
        setItemByID(response.data[0]);
        setCostPrice(
          response.data.length > 0 ? response.data[0].cost_price : 0
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleInputChange = (event) => {
    setSalesOrderItem(() => ({
      ...salesOrderItem,
      [event.target.name]: event.target.value,
    }));
  };

  const itemAmount = salesOrderItem.quantity * costPrice;
  const sgstAmount =
    (salesOrderItem.quantity * costPrice * itemByID?.sgst_percentage) / 100;
  const cgstAmount =
    (salesOrderItem.quantity * costPrice * itemByID?.cgst_percentage) / 100;
  const igstAmount =
    (salesOrderItem.quantity * costPrice * itemByID?.igst_percentage) / 100;
  const totalTax =
    (salesOrderItem.quantity * costPrice * itemByID?.sgst_percentage) / 100 +
    (salesOrderItem.quantity * costPrice * itemByID?.cgst_percentage) / 100 +
    (salesOrderItem.quantity * costPrice * itemByID?.igst_percentage) / 100;

  const totalAmount =
    salesOrderItem.quantity * costPrice +
    ((salesOrderItem.quantity * costPrice * itemByID?.sgst_percentage) / 100 +
      (salesOrderItem.quantity * costPrice * itemByID?.cgst_percentage) / 100 +
      (salesOrderItem.quantity * costPrice * itemByID?.igst_percentage) / 100);

  const requestData = {
    delivery_challan_id: id,
    item_detail_id: itemId,
    item_name: itemByID?.item_name,
    item_description: itemByID?.description,
    hsn_code: itemByID?.hsn_code,
    sac_code: itemByID?.sac_code,
    delivery_date: salesOrderItem.delivery_date,
    quantity: salesOrderItem.quantity,
    cost_price: costPrice,
    item_amount: itemAmount,
    sgst_percentage: itemByID?.sgst_percentage,
    cgst_percentage: itemByID?.cgst_percentage,
    igst_percentage: itemByID?.igst_percentage,
    sgst_amount: sgstAmount,
    cgst_amount: cgstAmount,
    igst_amount: igstAmount,
    total_tax: totalTax,
    total_amount: totalAmount,
  };

  const onHandleSubmit = (e) => {
    if (AddedItemsList.length === 0) {
      toast.error("Please Add at Least One Item", {
        autoClose: 1500,
      });
    }
    axios
      .post(
        "/api/purple-fusion/delivarychallanitem/create",
        AddedItemsList,
        headers
      )
      .then((response) => {
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,

              onClose: () => {
                if (
                  erplist.some(
                    (item) => item.erp_module_id === 25 && item.add && item.view
                  )
                ) {
                  navigate(
                    `/delivarychallanitem/list/${id}/${delivery_challan_type_id}/${customer_id}?someKey=true`
                  );
                  setvisible(false);
                } else {
                  toast.warning(
                    "don't have access to sales order other deatial",
                    {
                      autoClose: 2000,
                      onClose: () => {
                        navigate(`/salesorder/list`);
                        setvisible(false);
                      },
                    }
                  );
                }
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
        setvisible(false);
        navigate("*");
      });
  };

  const [AddedItemsList, setAddedItemsList] = useState([]);
  const HandleAdd = () => {
    if (requestData.quantity === "" || requestData.item_detail_id === "") {
      toast.error("Please fill the all required fields", {
        autoClose: 2000,
      });
      return;
    }
    if (requestData?.hsn_code === null && requestData?.sac_code === null) {
      toast.error("Please add tax to selected item", {
        autoClose: 2000,
      });
      return;
    }
    const isItemAlreadyAdded = AddedItemsList.some(
      (item) => item.item_detail_id === requestData.item_detail_id
    );

    if (isItemAlreadyAdded) {
      toast.error("Item is already added to the list", {
        autoClose: 2000,
      });
      return;
    }

    setAddedItemsList((prevItemsList) => [...prevItemsList, requestData]);

    // Reset input fields

    setselecteditem(null);
    setItemByID({});
    setCostPrice("");
    setSalesOrderItem({
      delivery_challan_id: id,
      item_detail_id: "",
      delivery_date: "",
      cost_price: "",
      quantity: "",
    });

    const item_detail_id = document.querySelector(
      'select[name="item_detail_id"]'
    );
    const item_description = document.querySelector(
      'input[name="item_description"]'
    );
    const hsn_code = document.querySelector('input[name="hsn_code"]');
    const sac_code = document.querySelector('input[name="sac_code"]');
    const quantity = document.querySelector('input[name="quantity"]');
    const cost_price = document.querySelector('input[name="cost_price"]');
    const item_amount = document.querySelector('input[name="item_amount"]');
    const sgst_percentage = document.querySelector(
      'input[name="sgst_percentage"]'
    );
    const cgst_percentage = document.querySelector(
      'input[name="cgst_percentage"]'
    );
    const igst_percentage = document.querySelector(
      'input[name="igst_percentage"]'
    );
    const sgst_amount = document.querySelector('input[name="sgst_amount"]');
    const cgst_amount = document.querySelector('input[name="cgst_amount"]');
    const igst_amount = document.querySelector('input[name="igst_amount"]');
    const total_tax = document.querySelector('input[name="total_tax"]');
    const total_amount = document.querySelector('input[name="total_amount"]');

    if (
      item_detail_id &&
      item_description &&
      hsn_code &&
      sac_code &&
      quantity &&
      cost_price &&
      item_amount &&
      sgst_percentage &&
      cgst_percentage &&
      igst_percentage &&
      sgst_amount &&
      cgst_amount &&
      igst_amount &&
      total_tax &&
      total_amount
    ) {
      item_detail_id.value = "";
      item_description.value = "";
      hsn_code.value = "";
      sac_code.value = "";
      quantity.value = "";
      cost_price.value = "";
      item_amount.value = "";
      sgst_percentage.value = "";
      cgst_percentage.value = "";
      igst_percentage.value = "";
      sgst_amount.value = "";
      cgst_amount.value = "";
      igst_amount.value = "";
      total_tax.value = "";
      total_amount.value = "";
    }
  };
  const HandleDelete = (id) => {
    const newList = AddedItemsList.filter((obj) => obj.item_detail_id !== id);
    setAddedItemsList(newList);
  };
  const handleEdit = (index) => {
    setEditIndex(index);
  };

  const handleSaveEdit = (index) => {
    setEditIndex(null);
  };

  const handleEditQuantityChange = (e, index) => {
    const newQuantity = e.target.value;
    setAddedItemsList((prevItemsList) =>
      prevItemsList.map((item, i) => {
        if (i === index) {
          const newAmount =
            parseFloat(item.cost_price) * parseFloat(newQuantity);
          const newsgstAmount =
            (parseFloat(newQuantity) *
              parseFloat(item.cost_price) *
              parseFloat(item.sgst_percentage)) /
            100;
          const newcgstAmount =
            (parseFloat(newQuantity) *
              parseFloat(item.cost_price) *
              parseFloat(item.cgst_percentage)) /
            100;
          const newigstAmount =
            (parseFloat(newQuantity) *
              parseFloat(item.cost_price) *
              parseFloat(item.igst_percentage)) /
            100;

          const newTotalTax =
            (parseFloat(newQuantity) *
              parseFloat(item.cost_price) *
              parseFloat(item.sgst_percentage)) /
              100 +
            (parseFloat(newQuantity) *
              parseFloat(item.cost_price) *
              parseFloat(item.cgst_percentage)) /
              100 +
            (parseFloat(newQuantity) *
              parseFloat(item.cost_price) *
              parseFloat(item.igst_percentage)) /
              100;

          const newTotalAmount =
            parseFloat(newQuantity) * parseFloat(item.cost_price) +
            ((parseFloat(newQuantity) *
              parseFloat(item.cost_price) *
              parseFloat(item.sgst_percentage)) /
              100 +
              (parseFloat(newQuantity) *
                parseFloat(item.cost_price) *
                parseFloat(item.cgst_percentage)) /
                100 +
              (parseFloat(newQuantity) *
                parseFloat(item.cost_price) *
                parseFloat(item.igst_percentage)) /
                100);

          return {
            ...item,

            quantity: newQuantity,
            item_amount: newAmount,
            sgst_amount: newsgstAmount,
            cgst_amount: newcgstAmount,
            igst_amount: newigstAmount,
            total_tax: newTotalTax,
            total_amount: newTotalAmount,
          };
        } else {
          return item;
        }
      })
    );
  };

  const handleEditCostPriceChange = (e, index) => {
    const newCostPrices = e.target.value;

    setAddedItemsList((prevItemsList) =>
      prevItemsList.map((item, i) => {
        if (i === index) {
          const newAmount =
            parseFloat(newCostPrices) * parseFloat(item.quantity);
          const newsgstAmount =
            (parseFloat(item.quantity) *
              parseFloat(newCostPrices) *
              parseFloat(item.sgst_percentage)) /
            100;
          const newcgstAmount =
            (parseFloat(item.quantity) *
              parseFloat(newCostPrices) *
              parseFloat(item.cgst_percentage)) /
            100;
          const newigstAmount =
            (parseFloat(item.quantity) *
              parseFloat(newCostPrices) *
              parseFloat(item.igst_percentage)) /
            100;

          const newTotalTax =
            (parseFloat(item.quantity) *
              parseFloat(newCostPrices) *
              parseFloat(item.sgst_percentage)) /
              100 +
            (parseFloat(item.quantity) *
              parseFloat(newCostPrices) *
              parseFloat(item.cgst_percentage)) /
              100 +
            (parseFloat(item.quantity) *
              parseFloat(newCostPrices) *
              parseFloat(item.igst_percentage)) /
              100;

          const newTotalAmount =
            parseFloat(item.quantity) * parseFloat(newCostPrices) +
            ((parseFloat(item.quantity) *
              parseFloat(newCostPrices) *
              parseFloat(item.sgst_percentage)) /
              100 +
              (parseFloat(item.quantity) *
                parseFloat(newCostPrices) *
                parseFloat(item.cgst_percentage)) /
                100 +
              (parseFloat(item.quantity) *
                parseFloat(newCostPrices) *
                parseFloat(item.igst_percentage)) /
                100);

          return {
            ...item,
            cost_price: newCostPrices,
            item_amount: newAmount,
            sgst_amount: newsgstAmount,
            cgst_amount: newcgstAmount,
            igst_amount: newigstAmount,
            total_tax: newTotalTax,
            total_amount: newTotalAmount,
          };
        } else {
          return item;
        }
      })
    );
  };

  const customStyles = {
    content: {
      width: "95%",
      height: "85%",
      margin: "auto",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  const filterOptions = (candidate, input) => {
    return (
      candidate.label.toLowerCase()?.includes(input.toLowerCase()) ||
      candidate.data.code.toLowerCase()?.includes(input.toLowerCase()) ||
      candidate.data.code_op.toLowerCase()?.includes(input.toLowerCase())
    );
  };
  const customStylesSelect = {
    control: (provided) => ({
      ...provided,
      width: "250px", // Adjust control width
    }),
    menu: (provided) => ({
      ...provided,
      width: "450px",
    }),
  };

  const formatOptionLabel = ({ label, code, code_op }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ marginLeft: 0 }}>{label}</div>
      <div style={{ marginLeft: 20 }}>{code_op}</div>
      <div style={{ marginLeft: 20 }}>{code}</div>
    </div>
  );

  // if  delivery_challan_type_id is 4

  const [checkedQuantities, setCheckedQuantities] = useState([]);
  const [resetTableKey, setResetTableKey] = useState(0);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  // const [itemListforBom, setItemLists] = useState([]);
  const [bomListFromBomMaster, setBomListFromBomMaster] = useState([]);
  const [bomMasterId, setBomMasterId] = useState([]);
  const [runfuntion, setRunFunction] = useState(false);
  const [finishedGoodQuntity, setFinishGoodQuntity] = useState(1);
  const [bomRawMaterialList, setBomRawMaterialList] = useState([]);
  const [isBomPresent, setIsBomPresent] = useState([]);
  const [resetCodeKey, setResetCodeKey] = useState(0);

  // console.log(isBomPresent);

  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");
    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  console.log(bomMasterId);
  const validationSchema = Yup.object().shape({
    bom_master_id: Yup.string().required("BOM is required"),
    item_detail_id: Yup.string().required("Item is required"),
  });
  const formik = useFormik({
    initialValues: {
      delivery_challan_id: id,
      item_detail_id: "",
      quantity: "",
      cost_price: "",
      bom_master_id: "", //for validation purpose only
      item_detail_id: "", //for validation purpose only
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  useEffect(() => {
    if (delivery_challan_type_id == 4) {
      getItemsListforLastDCType();
    }
  }, []);

  const itemLists = { item_category_id: 3 };
  const getItemsListforLastDCType = () => {
    axios
      .post("/api/purple-fusion/itemdetail/get", itemLists, headers)
      .then((res) => {
        setitemListLastDCType(res.data);
        console.log(res.data);
      });
  };
  const sorteditemListforLastDCType = itemListForLastDCType
    .slice()
    .sort((a, b) => b.id - a.id);

  const getBomListFromBomMaster = (itemDetilasId) => {
    console.log(itemDetilasId);
    axios
      .post(
        "/api/purple-fusion/bom/get",
        { item_detail_id: itemDetilasId },
        headers
      )
      .then((res) => {
        setBomListFromBomMaster(res.data);
        console.log(res.data);
      });
  };

  const sortedBomListFromBOM = bomListFromBomMaster
    .slice()
    .sort((a, b) => b.id - a.id);
  const getBomRawMaterial = (bomMasterId) => {
    axios
      .post(
        "/api/purple-fusion/delivarychallanitem/getBomRawMaterialInBomfordeliverychallan",
        {
          bom_master_id: bomMasterId,
          delivery_challan_id: id,
        },
        headers
      )
      .then((response) => {
        console.log(response.data);
        setBomRawMaterialList(response.data);
        // console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const mergedData = (data) => {
    // setCheckedQuantities([...checkedQuantities, ...data])
    const updatedArray = [...checkedQuantities];

    data.forEach((item) => {
      const index = updatedArray.findIndex(
        (el) => el.item_detail_id === item.item_detail_id
      );
      if (index !== -1) {
        updatedArray[index].quantity += item.quantity;
      } else {
        updatedArray.push(item);
      }
    });
    setCheckedQuantities(updatedArray);
  };

  const handleFormSubmit = () => {
    const newArray = checkedQuantities
      .filter((item) => item.checked === true)
      .map((item) => ({
        delivery_challan_id: id,
        item_detail_id: item.item_detail_id,
        quantity: item.quantity * finishedGoodQuntity,
        cost_price: item.cost_price,
      }));

    console.log(newArray);
    axios
      .post("/api/purple-fusion/delivarychallanitem/create", newArray, headers)
      .then((response) => {
        console.log(response.data);
        setRunFunction(true);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);
                navigate(
                  `/delivarychallanitem/list/${id}/${delivery_challan_type_id}/${customer_id}`
                );
              },
            })
          : toast.error(message, {
              autoClose: 2000,
            });
      })
      .catch((error) => {
        console.log(error);
        setvisible(false);
        navigate("*");
      });

    for (let i = 0; i < bomMasterId.length; i++) {
      const deliverychallanbom_obj = {
        delivery_challan_id: id,
        bom_master_id: bomMasterId[i],
      };

      axios
        .post(
          "/api/purple-fusion/deliverychallanbom/create",
          deliverychallanbom_obj,
          headers
        )
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
          setvisible(false);
          navigate("*");
        });
    }
  };

  const handleToggle = (itemId) => {
    setCheckedQuantities((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.id === itemId
          ? {
              ...item,
              checked: !item.checked,
            }
          : item
      );

      const allChecked = updatedItems.every((item) => item.checked);
      setSelectAllChecked(allChecked);
      return updatedItems;
    });
  };

  const handleSelectAll = () => {
    setCheckedQuantities((prevItems) => {
      const allChecked = !selectAllChecked;
      return prevItems.map((item) => ({ ...item, checked: allChecked }));
    });

    setSelectAllChecked(!selectAllChecked);
  };

  const handleQuntityChangeforItemInBom = (itemId, value) => {
    setCheckedQuantities((prevItems) =>
      prevItems.map((item) =>
        item.id === itemId ? { ...item, quantity: value } : item
      )
    );
  };
  // console.log(bomRawMaterialList);

  useEffect(() => {
    // setSelectAllChecked(false);
    setResetCodeKey((prevKey) => prevKey + 1);
  }, [formik.values.item_detail_id]);

  const handleButtonClick = () => {
    if (bomRawMaterialList.length > 0) {
      const bomMasterId = bomRawMaterialList[0].bom_master_id;
      if (isBomPresent.includes(bomMasterId)) {
        toast.error("Selected BOM Raw Material Already Present", {
          autoClose: 1500,
        });
      } else {
        mergedData(bomRawMaterialList);
        setIsBomPresent([...isBomPresent, bomMasterId]);
      }
    }
  };

  return (
    <>
      {erplist.some((item) => item.erp_module_id === 51 && item.add) ? (
        <div>
          {(delivery_challan_type_id == 1 ||
            delivery_challan_type_id == 2 ||
            delivery_challan_type_id == 3) && (
            <div>
              <Modal isOpen={visible} style={customStyles}>
                <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                  <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                    <div className="flex flex-1 flex-col gap-[10px] justify-start md:px-5 w-full">
                      <div className="flex flex-row w-[100%] pt-3 px-2 items-center justify-center">
                        <div className="flex flex-row sm:gap-15 items-center justify-start w-full ">
                          <Text
                            className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px] "
                            size="txtInterMedium24"
                          >
                            Delivery Challan Items
                          </Text>
                        </div>
                        <div className="flex flex-row items-center  justify-end">
                          <Button
                            className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                            shape="round"
                            color="blue_A700"
                            size="base"
                            variant="fill"
                            onClick={(e) => onHandleSubmit(e)}
                          >
                            Save
                          </Button>
                          <Button
                            className="cursor-pointer sticky font-small mb-3 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                            shape="round"
                            color="white"
                            size="base"
                            variant="fill"
                            onClick={() => {
                              setvisible(false);
                              // navigate(`/salesorder/list`);
                              navigate(
                                `/delivarychallanitem/list/${id}/${delivery_challan_type_id}/${customer_id}`
                              );
                            }}
                          >
                            ╳
                          </Button>
                        </div>
                      </div>
                      <div className="flex flex-col items-center justify-start md:ml-[0] mx-4 md:w-full  ">
                        <ToastContainer />
                        <div className="flex flex-col items-center justify-start  w-full">
                          <div className="md:gap-5 gap-3 grid md:grid-cols-1 grid-cols-1 justify-center min-h-[full] w-full h-[65vh]">
                            <div class="relative overflow-x-auto rounded-lg bg-gray-50">
                              <table className="min-w-full bg-white border">
                                <thead>
                                  <tr className="bg-gray-200">
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      Action
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      Item Name
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      Quantity
                                    </td>

                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      Cost Price
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      Item Amount
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      Total Taxable Amount
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      {" "}
                                      HSN Code
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      SAC Code
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      SGST %
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      CGST %
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      IGST %
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      {" "}
                                      SGST Amount
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      CGST Amount
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      IGST Amount
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      Total Tax
                                    </td>
                                    <td className="py-2 px-6 border-b text-center whitespace-nowrap">
                                      Item Desciption
                                    </td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {AddedItemsList?.map((item, index) => (
                                    <tr
                                      key={index}
                                      className="hover:bg-white-A700"
                                    >
                                      <td className="py-2 px-4 border-b text-center items-center justify-center flex flex-row gap-2">
                                        <div>
                                          <Button
                                            className="cursor-pointer whitespace-nowrap font-small min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                                            shape="round"
                                            color="blue_A700"
                                            size="base"
                                            variant="fill"
                                          >
                                            {editIndex === index ? (
                                              <Button
                                                className="cursor-pointer whitespace-nowrap font-small min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                                                shape="round"
                                                color="blue_A700"
                                                size="base"
                                                variant="fill"
                                                onClick={() =>
                                                  handleSaveEdit(index)
                                                }
                                              >
                                                Save
                                              </Button>
                                            ) : (
                                              <div>
                                                <Button
                                                  className="cursor-pointer whitespace-nowrap font-small min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                                                  shape="round"
                                                  color="blue_A700"
                                                  size="base"
                                                  variant="fill"
                                                  onClick={() =>
                                                    handleEdit(index)
                                                  }
                                                >
                                                  Edit
                                                </Button>
                                              </div>
                                            )}
                                          </Button>
                                        </div>
                                        <div
                                          className="flex flex-row items-center justify-center text-center hover:cursor-pointer"
                                          onClick={() => {
                                            HandleDelete(item.item_detail_id);
                                          }}
                                        >
                                          <FaRegTrashCan />
                                        </div>
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.item_name}
                                      </td>
                                      <td className="py-2 px-4 border-b text-center">
                                        {editIndex === index ? (
                                          <input
                                            className="w-full hover:shadow-md h-full"
                                            type="number"
                                            value={item.quantity}
                                            onChange={(e) =>
                                              handleEditQuantityChange(e, index)
                                            }
                                          />
                                        ) : (
                                          item.quantity
                                        )}
                                      </td>

                                      <td className="py-2 px-4 border-b text-center">
                                        {editIndex === index ? (
                                          <input
                                            className="w-full hover:shadow-md h-full"
                                            type="number"
                                            value={item.cost_price}
                                            onChange={(e) =>
                                              handleEditCostPriceChange(
                                                e,
                                                index
                                              )
                                            }
                                          />
                                        ) : (
                                          item.cost_price
                                        )}
                                      </td>

                                      <td className="py-2 px-6 border-b text-center">
                                        {item.item_amount}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.total_amount}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.hsn_code ? item.hsn_code : "NA"}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.sac_code ? item.sac_code : "NA"}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.sgst_percentage}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.cgst_percentage}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.igst_percentage}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.sgst_amount}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.cgst_amount}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.igst_amount}
                                      </td>
                                      <td className="py-2 px-6 border-b text-center">
                                        {item.total_tax}
                                      </td>

                                      <td className="py-2 px-6 border-b text-center">
                                        {item.item_description}
                                      </td>
                                    </tr>
                                  ))}
                                  <tr>
                                    <td className="px-4 text-center">
                                      <Button
                                        className="cursor-pointer whitespace-nowrap font-small min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                                        shape="round"
                                        color="blue_A700"
                                        size="base"
                                        variant="fill"
                                        onClick={() => HandleAdd()}
                                      >
                                        Add
                                      </Button>
                                    </td>
                                    <td className="py-2 px-4 w-96 text-center">
                                      <Select
                                        name="item_detail_id"
                                        options={sortedItemList.map(
                                          (resstate) => ({
                                            label: resstate.name,
                                            value: resstate.id,
                                            code: resstate.code,
                                            code_op: resstate.code_op,
                                          })
                                        )}
                                        className="bg-white-A700 border border-gray-200_02 border-solid h-[40px] rounded-[10px] w-[250px]"
                                        onChange={(selectedOption, e) => {
                                          handleInputGet(e);
                                          setitemId(selectedOption.value);
                                          setselecteditem(selectedOption);
                                          itemsDetailsGetByID(
                                            selectedOption.value
                                          );
                                        }}
                                        value={selecteditem}
                                        placeholder="search item by name or codes"
                                        filterOption={filterOptions}
                                        formatOptionLabel={formatOptionLabel}
                                        styles={customStylesSelect}
                                      />
                                    </td>
                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="quantity"
                                        type="text"
                                        placeholder=" Enter Quantity "
                                        value={salesOrderItem.quantity}
                                        onChange={handleInputChange}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[140px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="cost_price"
                                        type="text"
                                        placeholder=" Enter Amount"
                                        value={costPrice}
                                        onChange={(e) => {
                                          setCostPrice(e.target.value);
                                        }}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[140px]"
                                      ></input>
                                    </td>
                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="item_amount"
                                        type="text"
                                        placeholder=" Enter Amount"
                                        readOnly
                                        value={(
                                          salesOrderItem.quantity * costPrice ||
                                          0
                                        ).toFixed(2)}
                                        onChange={handleInputChange}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[150px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="total_amount"
                                        type="text"
                                        placeholder=" Enter Total Amount "
                                        readOnly
                                        // value={fosalesOrderItemotal_amount}

                                        value={(
                                          salesOrderItem.quantity * costPrice +
                                            ((salesOrderItem.quantity *
                                              costPrice *
                                              itemByID?.sgst_percentage) /
                                              100 +
                                              (salesOrderItem.quantity *
                                                costPrice *
                                                itemByID?.cgst_percentage) /
                                                100 +
                                              (salesOrderItem.quantity *
                                                costPrice *
                                                itemByID?.igst_percentage) /
                                                100) || 0
                                        ).toFixed(2)}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[150px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="hsn_code"
                                        type="text"
                                        placeholder=" Enter HSN Code"
                                        readOnly
                                        onChange={handleInputChange}
                                        value={itemByID?.hsn_code || ""}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[155px]"
                                      ></input>
                                    </td>
                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="sac_code"
                                        type="text"
                                        placeholder=" Enter SAC Code"
                                        readOnly
                                        onChange={handleInputChange}
                                        value={itemByID?.sac_code || ""}
                                        // value={sacCode}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[155px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="sgst_percentage"
                                        type="text"
                                        placeholder=" Enter sgst percentage"
                                        readOnly
                                        onChange={handleInputChange}
                                        value={itemByID?.sgst_percentage || ""}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[155px]"
                                      ></input>
                                    </td>
                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="cgst_percentage"
                                        type="text"
                                        placeholder="Enter cgst percentage"
                                        readOnly
                                        onChange={handleInputChange}
                                        value={itemByID?.cgst_percentage || ""}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[150px]"
                                      ></input>
                                    </td>
                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="igst_percentage"
                                        type="text"
                                        placeholder=" Enter igst percentage"
                                        readOnly
                                        onChange={handleInputChange}
                                        value={itemByID?.igst_percentage || ""}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[150px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="sgst_amount"
                                        type="text"
                                        placeholder=" Enter sgst amount "
                                        readOnly
                                        onChange={handleInputChange}
                                        value={(
                                          (salesOrderItem.quantity *
                                            costPrice *
                                            itemByID?.sgst_percentage) /
                                            100 || 0
                                        ).toFixed(2)}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[150px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="cgst_amount"
                                        type="text"
                                        placeholder=" Enter cgst amount"
                                        readOnly
                                        onChange={handleInputChange}
                                        value={(
                                          (salesOrderItem.quantity *
                                            costPrice *
                                            itemByID?.cgst_percentage) /
                                            100 || 0
                                        ).toFixed(2)}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[150px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="igst_amount"
                                        type="text"
                                        placeholder=" Enter igst amount "
                                        readOnly
                                        onChange={handleInputChange}
                                        value={(
                                          (salesOrderItem.quantity *
                                            costPrice *
                                            itemByID?.igst_percentage) /
                                            100 || 0
                                        ).toFixed(2)}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[150px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="total_tax"
                                        type="text"
                                        placeholder=" Enter total tax"
                                        readOnly
                                        onChange={handleInputChange}
                                        value={(
                                          (salesOrderItem.quantity *
                                            costPrice *
                                            itemByID?.sgst_percentage) /
                                            100 +
                                            (salesOrderItem.quantity *
                                              costPrice *
                                              itemByID?.cgst_percentage) /
                                              100 +
                                            (salesOrderItem.quantity *
                                              costPrice *
                                              itemByID?.igst_percentage) /
                                              100 || 0
                                        ).toFixed(2)}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[150px]"
                                      ></input>
                                    </td>

                                    <td className="py-2 px-4 text-center">
                                      <input
                                        name="item_description"
                                        type="text"
                                        readOnly
                                        placeholder=" Enter Descreption"
                                        onChange={handleInputChange}
                                        value={itemByID?.description || ""}
                                        className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-[165px]"
                                      ></input>
                                    </td>
                                  </tr>
                                </tbody>

                                <tfoot
                                  className="text-sm w-full border-2 text-gray-800 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky bottom-0 "
                                  // className="text-gray-800 border-2 z-10 sticky bottom-0"
                                >
                                  <tr className="text-sm bg-gray-200">
                                    <td colSpan="2"> </td>
                                    <td className="px-10 py-1">
                                      <span className="text-black font-bold">
                                        TOTAL SUM
                                      </span>
                                    </td>
                                    <td className="px-10 py-1">
                                      {/* Sum of Taxable Amount */}
                                      {Number(
                                        AddedItemsList.reduce(
                                          (acc, item) =>
                                            Number(acc) +
                                            Number(item.cost_price),
                                          0
                                        )
                                      )?.toFixed(2)}
                                    </td>
                                    <td className="px-10 py-1">
                                      {/* Sum of Tax Amount */}
                                      {Number(
                                        AddedItemsList.reduce(
                                          (acc, item) =>
                                            Number(acc) +
                                            Number(item.item_amount),
                                          0
                                        )
                                      ).toFixed(2)}
                                    </td>
                                    <td className="px-10 py-1">
                                      {/* Sum of Total Amount */}
                                      {Number(
                                        AddedItemsList.reduce(
                                          (acc, item) =>
                                            Number(acc) +
                                            Number(item.total_amount),
                                          0
                                        )
                                      ).toFixed(2)}
                                    </td>
                                    <td colSpan="5"> </td>
                                    <td className="px-10 py-1">
                                      {/* Sum of SGST Amount */}
                                      {Number(
                                        AddedItemsList.reduce(
                                          (acc, item) =>
                                            Number(acc) +
                                            Number(item.sgst_amount),
                                          0
                                        )
                                      ).toFixed(2)}
                                    </td>
                                    <td className="px-10 py-1">
                                      {/* Sum of CGST Amount */}
                                      {Number(
                                        AddedItemsList.reduce(
                                          (acc, item) =>
                                            Number(acc) +
                                            Number(item.cgst_amount),
                                          0
                                        )
                                      ).toFixed(2)}
                                    </td>
                                    <td className="px-10 py-1">
                                      {/* Sum of SGST Amount */}
                                      {Number(
                                        AddedItemsList.reduce(
                                          (acc, item) =>
                                            Number(acc) +
                                            Number(item.igst_amount),
                                          0
                                        )
                                      ).toFixed(2)}
                                    </td>

                                    <td className="px-10 py-1">
                                      {/* Sum of Total Tax Amount */}
                                      {Number(
                                        AddedItemsList.reduce(
                                          (acc, item) =>
                                            Number(acc) +
                                            Number(item.total_tax),
                                          0
                                        )
                                      ).toFixed(2)}
                                    </td>

                                    <td colSpan="10"> </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
          )}

          {delivery_challan_type_id == 4 && (
            <div>
              <Modal isOpen={visible} style={customStyles}>
                <form onSubmit={formik.handleSubmit}>
                  <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                    <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                      <div className="flex flex-1 flex-col gap-[19px] justify-start md:px-5 w-full">
                        <div>
                          <div className="flex flex-row items-center justify-start ">
                            <div className="flex flex-row  items-start justify-between w-full ">
                              <Text
                                className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px] "
                                size="txtInterMedium24"
                              >
                                Delivery Challan Items
                              </Text>
                            </div>
                            <div className="flex flex-row items-center justify-end ml-auto top-2 ">
                              <Button
                                className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] active:scale-90 transition-transform duration-200"
                                shape="round"
                                color="blue_A700"
                                size="base"
                                variant="fill"
                                type="submit"
                              >
                                Save
                              </Button>
                              <Button
                                className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] "
                                shape="round"
                                color="white"
                                size="base"
                                variant="fill"
                                se
                                onClick={() => {
                                  setvisible(false);
                                  navigate(
                                    `/delivarychallanitem/list/${id}/${delivery_challan_type_id}/${customer_id}`
                                  );
                                }}
                              >
                                ╳
                              </Button>
                            </div>
                          </div>
                          <ToastContainer />
                          <div className="flex flex-col items-center justify-start mt-4 w-full">
                            <div className="md:gap-5 gap-x-[75px] gap-y-[25px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                              <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                                <Text
                                  className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                                  size="txtInterMedium20Black700"
                                >
                                  <span className="text-black-700 font-inter font-small text-sm">
                                    Select Items
                                  </span>
                                  <span className="text-red-A700 font-inter font-small">
                                    *
                                  </span>
                                </Text>
                                <Select
                                  name="item_detail_id"
                                  options={sorteditemListforLastDCType.map(
                                    (resstate) => ({
                                      label: resstate.name,
                                      value: resstate.id,
                                    })
                                  )}
                                  className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                                  onChange={(selectedOption) => {
                                    formik.setFieldValue(
                                      "item_detail_id",
                                      selectedOption.value
                                    );
                                    getBomListFromBomMaster(
                                      selectedOption.value
                                    );
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Select Item"
                                />

                                {formik.touched.item_detail_id &&
                                formik.errors.item_detail_id ? (
                                  <div className="text-red-500 text-sm">
                                    {formik.errors.item_detail_id}
                                  </div>
                                ) : null}
                              </div>

                              <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full  mb-2">
                                <Text
                                  className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                                  size="txtInterMedium20Black700"
                                >
                                  <span className="text-black-700 font-inter font-samll text-sm">
                                    Select BOM
                                  </span>
                                  <span className="text-red-A700 font-inter font-samll text-sm">
                                    *
                                  </span>
                                </Text>
                                <Select
                                  name="bom_master_id"
                                  options={sortedBomListFromBOM.map(
                                    (resstate) => ({
                                      label: resstate.name,
                                      value: resstate.id,
                                    })
                                  )}
                                  className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                                  onChange={(selectedOption) => {
                                    formik.setFieldValue(
                                      "bom_master_id",
                                      selectedOption.value
                                    );
                                    getBomRawMaterial(selectedOption.value);
                                    setBomMasterId((prevIds) => [
                                      ...prevIds,
                                      selectedOption.value,
                                    ]);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Select Bom"
                                  key={resetCodeKey}
                                />
                                {formik.touched.bom_master_id &&
                                formik.errors.bom_master_id ? (
                                  <div className="text-red-500 text-sm">
                                    {formik.errors.bom_master_id}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-col items-center justify-start w-full">
                            <div className="md:gap-5 gap-x-[75px] gap-y-[25px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                              <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                                <Text
                                  className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                                  size="txtInterMedium20Black700"
                                >
                                  <span className="text-black-700 font-inter font-small text-sm">
                                    Number of Finished Goods to be Manufactured
                                  </span>
                                  <span className="text-red-A700 font-inter font-small">
                                    *
                                  </span>
                                </Text>
                                <input
                                  defaultValue={1}
                                  type="text"
                                  placeholder=" Enter number"
                                  onChange={(e) => {
                                    setFinishGoodQuntity(e.target.value);
                                  }}
                                  className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                                ></input>
                              </div>

                              <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-6">
                                <button
                                  className="cursor-pointer font-medium mb-1.5 min-w-[70px] bg-blue-A700 text-white-A700 rounded-[7px] text-center text-xl tracking-[0.20px] active:scale-90 transition-transform duration-200"
                                  shape="round"
                                  color="blue_A700"
                                  size="base"
                                  variant="fill"
                                  type="button"
                                  onClick={handleButtonClick}
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-col items-center justify-start mt-3 w-full ">
                            <div className="md:gap-5 gap-[50px] grid md:grid-cols-1 grid-cols-1 justify-center min-h-[auto] w-full">
                              <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full overflow-auto min-h-[400px]">
                                <table
                                  key={resetTableKey}
                                  className="min-w-full  font-inter whitespace-nowrap text-gray-800 text-sm text-left dark:text-gray-400 "
                                >
                                  <thead className="text-sm w-full border-2 text-gray-800 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr className="bg-gray-200">
                                      <th className="px-6 py-4">
                                        <label>
                                          <input
                                            type="checkbox"
                                            onClick={handleSelectAll}
                                            className="rounded-[5px]"
                                            checked={selectAllChecked}
                                          />
                                          {"   "} All
                                        </label>
                                      </th>

                                      <th className="px-6 py-4">ITEM NAME</th>

                                      <th className="px-6 py-4">CODE</th>

                                      <th className="px-6 py-4">
                                        PROVIDED CODE
                                      </th>

                                      <th className="px-6 py-4">QUANTITY</th>

                                      <th className="px-6 py-4">COST PRICE</th>

                                      <th className="px-6 py-4">HSN</th>

                                      <th className="px-6 py-4">SAC</th>

                                      <th className="px-6 py-4">ITEM AMOUNT</th>

                                      <th className="px-6 py-4">SGST %</th>

                                      <th className="px-6 py-4">CGST %</th>

                                      <th className="px-6 py-4">IGST %</th>

                                      <th className="px-6 py-4">SGST AMOUNT</th>

                                      <th className="px-6 py-4">CGST AMOUNT</th>

                                      <th className="px-6 py-4">IGST AMOUNT</th>

                                      <th className="px-6 py-4">TOTAL TAX</th>

                                      <th className="px-6 py-4">
                                        TOTAL AMOUNT
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="text-gray-800 border-2">
                                    {checkedQuantities.map((item) => (
                                      <tr key={item.id}>
                                        <td className="px-6 py-4">
                                          <input
                                            className="rounded-[5px]"
                                            type="checkbox"
                                            id={`item-${item.id}`}
                                            checked={item.checked}
                                            onChange={() =>
                                              handleToggle(item.id)
                                            }
                                          />
                                        </td>
                                        <td className="px-6 py-4">
                                          {item.raw_item_name}
                                        </td>
                                        <td className="px-6 py-4">
                                          {item.code}
                                        </td>
                                        <td className="px-6 py-4">
                                          {item.code_op}
                                        </td>
                                        <td className="px-6 py-4">
                                          <input
                                            className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                                            type="text"
                                            value={
                                              item.quantity *
                                              finishedGoodQuntity
                                            }
                                            onChange={(e) =>
                                              handleQuntityChangeforItemInBom(
                                                item.id,
                                                e.target.value
                                              )
                                            }
                                            disabled={!item.checked}
                                          />
                                        </td>

                                        <td className="px-6 py-4">
                                          {item.cost_price}
                                        </td>

                                        <td className="px-6 py-4">
                                          {item.hsn_code}
                                        </td>
                                        <td className="px-6 py-4">
                                          {item.sac_code}
                                        </td>
                                        <td className="px-6 py-4">
                                          {(
                                            item.quantity *
                                            finishedGoodQuntity *
                                            item.cost_price
                                          ).toFixed(2)}
                                        </td>
                                        <td className="px-6 py-4">
                                          {item.sgst_percentage}
                                        </td>
                                        <td className="px-6 py-4">
                                          {item.cgst_percentage}
                                        </td>
                                        <td className="px-6 py-4">
                                          {item.igst_percentage}
                                        </td>

                                        <td className="px-6 py-4">
                                          {(
                                            (item.quantity *
                                              finishedGoodQuntity *
                                              item.cost_price *
                                              item?.sgst_percentage) /
                                              100 || 0
                                          ).toFixed(2)}
                                        </td>
                                        <td className="px-6 py-4">
                                          {(
                                            (item.quantity *
                                              finishedGoodQuntity *
                                              item.cost_price *
                                              item?.cgst_percentage) /
                                              100 || 0
                                          ).toFixed(2)}
                                        </td>

                                        <td className="px-6 py-4">
                                          {(
                                            (item.quantity *
                                              finishedGoodQuntity *
                                              item.cost_price *
                                              item?.igst_percentage) /
                                              100 || 0
                                          ).toFixed(2)}
                                        </td>

                                        <td className="px-6 py-4">
                                          {(
                                            (item.quantity *
                                              finishedGoodQuntity *
                                              item.cost_price *
                                              item?.sgst_percentage) /
                                              100 +
                                              (item.quantity *
                                                finishedGoodQuntity *
                                                item.cost_price *
                                                item?.cgst_percentage) /
                                                100 +
                                              (item.quantity *
                                                finishedGoodQuntity *
                                                item.cost_price *
                                                item?.igst_percentage) /
                                                100 || 0
                                          ).toFixed(2)}
                                        </td>

                                        <td className="px-6 py-4">
                                          {(
                                            item.quantity *
                                              finishedGoodQuntity *
                                              item.cost_price +
                                              ((item.quantity *
                                                finishedGoodQuntity *
                                                item.cost_price *
                                                item?.sgst_percentage) /
                                                100 +
                                                (item.quantity *
                                                  finishedGoodQuntity *
                                                  item.cost_price *
                                                  item?.cgst_percentage) /
                                                  100 +
                                                (item.quantity *
                                                  finishedGoodQuntity *
                                                  item.cost_price *
                                                  item?.igst_percentage) /
                                                  100) || 0
                                          ).toFixed(2)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>

                                  {bomMasterId != undefined && (
                                    <tfoot
                                      className="text-sm w-full border-2 text-gray-800 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky bottom-0 "
                                      // className="text-gray-800 border-2 z-10 sticky bottom-0"
                                    >
                                      <tr className="text-sm bg-gray-200">
                                        <td colSpan="4"> </td>
                                        <td className="px-4 py-1">
                                          <span className="text-black font-bold">
                                            TOTAL SUM
                                          </span>
                                        </td>

                                        <td className="px-4 py-1">
                                          {/* Sum of COST PRICE */}
                                          {checkedQuantities
                                            .reduce(
                                              (acc, item) =>
                                                acc + (item.cost_price || 0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </td>
                                        <td colSpan="2"> </td>
                                        <td className="px-4 py-1">
                                          {/* Sum of  Amount */}

                                          {checkedQuantities
                                            .reduce(
                                              (acc, item) =>
                                                acc +
                                                (item.cost_price *
                                                  (item.quantity *
                                                    finishedGoodQuntity) || 0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </td>
                                        <td colSpan="3"> </td>
                                        <td className="px-4 py-1">
                                          {/* Sum of  SGST Amount */}
                                          {checkedQuantities
                                            .reduce(
                                              (acc, item) =>
                                                acc +
                                                ((item.quantity *
                                                  finishedGoodQuntity *
                                                  item.cost_price *
                                                  item?.sgst_percentage) /
                                                  100 || 0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </td>

                                        <td className="px-4 py-1">
                                          {/* Sum of  CGST Amount */}
                                          {checkedQuantities
                                            .reduce(
                                              (acc, item) =>
                                                acc +
                                                ((item.quantity *
                                                  finishedGoodQuntity *
                                                  item.cost_price *
                                                  item?.cgst_percentage) /
                                                  100 || 0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </td>

                                        <td className="px-4 py-1">
                                          {/* Sum of  Igst Amount */}
                                          {checkedQuantities
                                            .reduce(
                                              (acc, item) =>
                                                acc +
                                                ((item.quantity *
                                                  finishedGoodQuntity *
                                                  item.cost_price *
                                                  item?.igst_percentage) /
                                                  100 || 0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </td>

                                        <td className="px-4 py-1">
                                          {/* Sum of total tax */}
                                          {checkedQuantities
                                            .reduce(
                                              (acc, item) =>
                                                acc +
                                                ((item.quantity *
                                                  finishedGoodQuntity *
                                                  item.cost_price *
                                                  item?.sgst_percentage) /
                                                  100 +
                                                  (item.quantity *
                                                    finishedGoodQuntity *
                                                    item.cost_price *
                                                    item?.cgst_percentage) /
                                                    100 +
                                                  (item.quantity *
                                                    finishedGoodQuntity *
                                                    item.cost_price *
                                                    item?.igst_percentage) /
                                                    100 ||
                                                  0 ||
                                                  0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </td>

                                        <td className="px-4 py-1">
                                          {/* Sum of total amount */}
                                          {checkedQuantities
                                            .reduce(
                                              (acc, item) =>
                                                acc +
                                                (item.quantity *
                                                  finishedGoodQuntity *
                                                  item.cost_price +
                                                  ((item.quantity *
                                                    finishedGoodQuntity *
                                                    item.cost_price *
                                                    item?.sgst_percentage) /
                                                    100 +
                                                    (item.quantity *
                                                      finishedGoodQuntity *
                                                      item.cost_price *
                                                      item?.cgst_percentage) /
                                                      100 +
                                                    (item.quantity *
                                                      finishedGoodQuntity *
                                                      item.cost_price *
                                                      item?.igst_percentage) /
                                                      100) ||
                                                  0 ||
                                                  0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </td>

                                        <td colSpan="10"> </td>
                                      </tr>
                                    </tfoot>
                                  )}
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </Modal>
            </div>
          )}
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default DeliveryChallanItemAdd;
